import I18n from 'I18n';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import { FETCH_OBJECT_LISTS_QUERY, FETCH_LISTS_BY_IDS, FETCH_LISTS_BY_NAME } from './fetchObjectLists';
import { jsx as _jsx } from "react/jsx-runtime";
export const PAGE_SIZE = 25;
const ListMembershipFilter = ({
  filteredLists,
  objectType,
  onChange
}) => {
  const [savedOptions, setSavedOptions] = useState([]);
  const {
    fetchMore
  } = useQuery(FETCH_OBJECT_LISTS_QUERY, {
    variables: {
      currentObject: objectType,
      after: null,
      pageSize: 0
    }
  });
  const {
    fetchMore: fetchMoreSearchResults
  } = useQuery(FETCH_LISTS_BY_NAME, {
    variables: {
      name: ''
    }
  });
  const {
    data: savedLists
  } = useQuery(FETCH_LISTS_BY_IDS, {
    variables: {
      listIds: filteredLists
    }
  });
  useEffect(() => {
    if (savedLists) {
      setSavedOptions(savedLists.listOverview.edges.map(edge => ({
        text: edge.node.name,
        value: edge.node.id
      })));
    }
  }, [savedLists]);
  const mapAsyncResultsToOptions = ({
    callback,
    response
  }) => {
    return callback(null, {
      options: response.data.listOverview.edges.map(each => ({
        text: each.node.name,
        value: each.node.id
      })),
      pagination: {
        hasMore: response.data.listOverview.pageInfo.hasNextPage,
        after: response.data.listOverview.pageInfo.endCursor,
        pageSize: PAGE_SIZE
      }
    });
  };
  const loadListOptions = async (input, callback, pagination = {
    after: null,
    pageSize: PAGE_SIZE
  }) => {
    if (input) {
      const response = await fetchMoreSearchResults({
        variables: {
          name: input,
          pagination
        }
      });
      return mapAsyncResultsToOptions({
        callback,
        response
      });
    }
    const response = await fetchMore({
      variables: pagination
    });
    return mapAsyncResultsToOptions({
      callback,
      response
    });
  };
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "object-lists-filter",
    anchorType: "combined",
    clearable: true,
    loadOptions: loadListOptions,
    onChange: ({
      target: {
        value
      }
    }) => onChange(value),
    value: filteredLists.length > 0 ? filteredLists[0] : null,
    options: savedOptions,
    placeholder: I18n.text('reporting-snowflake.filter-editor.list-membership.select-list-placeholder')
  });
};
export default ListMembershipFilter;